import Phaser from "phaser";
import i18next from "i18next";
import { COLORS } from "../../../../ui/colors";
import { playSound } from "../../../../utils/sound-utils";
import { drawWidgetBackground, QUEST_WIDGET_W } from "./widget-background";

const WIDGET_H = 84;

// Compact card that just shows THE GAUNTLET logo — tapping it opens the full
// gauntlet-screen overlay so the player can check their run's progress on demand
// (outside of the automatic post-extraction reveal).
export class GauntletWidget extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x: number, y: number, onClick: () => void) {
    super(scene, x, y);

    // bgX/bgY match the other quest widgets' inset convention so left edges line up.
    const bgX = 8;
    const bgY = -16;
    const bg = scene.add.graphics();
    drawWidgetBackground(bg, bgX, bgY, QUEST_WIDGET_W, WIDGET_H);
    this.add(bg);

    const centerX = bgX + QUEST_WIDGET_W / 2;

    const logo = scene.add.image(centerX, bgY + WIDGET_H / 2 - 10, "gauntlet-logo");
    const maxLogoW = QUEST_WIDGET_W - 32;
    logo.setScale(Math.min(1, maxLogoW / logo.width));
    this.add(logo);

    const caption = scene.add
      .text(centerX, bgY + WIDGET_H - 16, i18next.t("ui:instructions.tapToView"), {
        fontSize: "11px",
        color: COLORS.WHITE,
        fontFamily: "Anton",
      })
      .setOrigin(0.5);
    this.add(caption);

    this.setInteractive({
      hitArea: new Phaser.Geom.Rectangle(bgX, bgY, QUEST_WIDGET_W, WIDGET_H),
      hitAreaCallback: Phaser.Geom.Rectangle.Contains,
      useHandCursor: true,
    });
    this.on("pointerup", () => {
      playSound(scene, "menu-click-sound");
      onClick();
    });
  }
}
